import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../../shared/utils/utils";
import { RootState } from "../../../shared/types/common";
import { Drawer } from "antd";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { useForm } from "antd/lib/form/Form";
import moment from "moment";
import { useEffect, useState } from "react";
import { createDepartment, updateDepartmentById } from "../../../core/store/reducers/department.slice";
import { Client } from "../../../core/api-client";
import { API_GET_ALL_STAFF_LIST } from "../../../shared/routes/private.routes";


interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: () => void;
}
const CreateEditDepartmentComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const { user } = useSelector((state: RootState) => state.auth);
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [staffList, setStaffList] = useState<any[]>([]);

  const onFinish = (values: any) => {
    if (selectedEntity) {
      const payload = {
        departmentName: values?.departmentName,
        headOfDepartmentId: values?.headOfDepartment,
        status: values?.status,
      };
      dispatch(updateDepartmentById({departmentId: selectedEntity?.departmentId,body: payload})).then((val: any) => {
        if (val?.payload?.data) {
          showNotification("Department Details Updated Successfully", "success");
          onSubmit();
        }
      });
    } else {
      const payload = {
        // ...values,
        departmentName: values?.departmentName,
        headOfDepartmentId: values?.headOfDepartment,
        status: values?.status,
      };
      dispatch(createDepartment(payload)).then(
        (val: any) => {
          if (val?.payload?.data) {
            showNotification("New Department Created Successfully", "success");
            onSubmit();
          }
        }
      );
    }
  };

  const fetchStaffList = async () => {
      const response = await Client.get(API_GET_ALL_STAFF_LIST);
      if(response?.data?.data){
        setStaffList(response?.data?.data); 
      }else{
        setStaffList([]); 
      }
    }

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        departmentName: selectedEntity?.departmentName,
        headOfDepartment: selectedEntity?.headOfDepartmentId,
        status: selectedEntity?.status,
      });
    }
    
  }, [form, selectedEntity]);
  
  useEffect(()=>{
    fetchStaffList();
  },[])

  const dropdownOptions = staffList.map((staff) => ({
    value: staff?.staffId, // Assuming 'id' is the unique identifier
    label: staff?.staffName, // Assuming 'name' is the display name
  }));

  const onFinishFailed = (_errorInfo: any) => {
    return;
  };

  const onValuesChange = (value: any, _allValues: any) => {
    
  };

  var colSpan = screenType.isPortrait ? 24 : 12;
  const formProps = {
    form: form,
    name: "creat-edit-department",
    heading: selectedEntity ? "Edit Department Details" : "Add New Department",
    initialValues: {
      status: "ACTIVE", 
    },
    formElements: [
      {
        name: "departmentName",
        colSpan: 12,
        label: "Department Name",
        placeholder: "Enter Department Name ",
        type: "Input",
        allowClear: true,
        rules: [{ required: true, message: "Please enter Department Name" }],
      },
      {
        name: 'status',
        label: 'Status',
        placeholder: 'Status',
        type: 'Select',
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: [{ value: 'ACTIVE', label: 'ACTIVE'},{value: 'INACTIVE', label: 'INACTIVE'}],
        rules: [{ required: true, message: "Please enter Status" }],
      },
      {
        name: 'headOfDepartment',
        label: 'Head Of Deaprtment',
        placeholder: 'Head Of Deaprtment',
        type: 'Select',
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: dropdownOptions,
        rules: [{ required: true, message: "Please enter Head Of Deaprtment" }],
      },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: false,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange,
  };
  return (
    <>
      <Drawer
        maskClosable={false}
        title={<strong>{formProps.heading}</strong>}
        className="form-drawer"
        width={screenType.isPortrait ? '90%' : (screenType.isLg || screenType.isXl ? 720 : 500)}
        onClose={onClose}
        open={visible}
      >
        <GenericFormComponent {...formProps} />
      </Drawer>
    </>
  );
};

export default CreateEditDepartmentComponent;
